import React from "react";
import { Star, QrCode as QrIcon } from "lucide-react";
import { PhoneMockup } from "./PhoneMockup";
import { StoreButtons } from "./StoreButtons";
import { useLang } from "../../i18n/LanguageContext";

export const Hero = () => {
  const { t } = useLang();
  return (
    <section id="top" className="relative overflow-hidden pt-28 sm:pt-32">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 pb-20 sm:px-8 lg:grid-cols-2 lg:pb-28">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-1.5 text-sm font-bold text-petrol shadow-sm">
            <span className="flex h-2 w-2 rounded-full bg-terracotta" />
            {t.hero.badge}
          </span>

          <h1 className="mt-5 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-petrol sm:text-5xl lg:text-6xl">
            {t.hero.titlePre}{" "}
            <span className="text-terracotta">{t.hero.titleHi}</span>
          </h1>

          <p className="mt-5 max-w-xl text-lg leading-relaxed text-petrol-soft">
            {t.hero.subtitle}
          </p>

          <div
            id="download"
            className="mt-8 flex flex-col gap-6 sm:flex-row sm:items-center"
          >
            <StoreButtons idPrefix="hero" />
            <div className="flex items-center gap-3 rounded-2xl bg-white p-3 shadow-sm">
              <div
                data-testid="hero-qr-placeholder"
                className="flex h-[72px] w-[72px] flex-col items-center justify-center rounded-xl border-2 border-dashed border-petrol/25 bg-cream text-petrol/40"
              >
                <QrIcon className="h-7 w-7" strokeWidth={1.5} />
              </div>
              <p className="text-xs font-bold leading-snug text-petrol-soft">
                {t.hero.qr1}<br />{t.hero.qr2}
              </p>
            </div>
          </div>

          <div className="mt-7 flex items-center gap-2 text-sm text-petrol-soft">
            <span className="flex text-terracotta">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-current" />
              ))}
            </span>
            <span className="font-semibold">{t.hero.rating}</span>
          </div>
        </div>

        <div className="relative">
          <PhoneMockup />
        </div>
      </div>
    </section>
  );
};
